export const forOffer = (rows, offerId) => (
  (rows || []).filter((row) => row.v3_offer_id == null || row.v3_offer_id === offerId)
);

export default forOffer;
